<template>
  <div class="container">
    <div class="title">{{ $t('with').Withdrawcurrency }}</div>
    <div class="info">
      <div class="left">
        <!-- 选择币种 -->
        <div class="tit">{{ $t('with').currencyofwithdrawal }}</div>
        <PopoverSelect :items="currencyArr" :onSelect="onSelectCurrency">
          <template #reference>
            <div class="selInfo">
              <div class="left">
                <img class="img" :src="require(`@/assets/img/${currency}.png`)" />
                <div class="name">{{ currency }}</div>
              </div>
              <van-icon name="play" size="13" class="ric" color="var(--text_color)" />
            </div>
          </template>
        </PopoverSelect>
        <!-- 选择网络 -->
        <div class="tit">{{ $t('recharge').network }}</div>
        <PopoverSelect :items="networkArr" :onSelect="onSelectNetwork">
          <template #reference>
            <div class="networkInfo">{{ network }}
              <span><van-icon name="play" size="13" class="ric" color="var(--text_color)" /></span>
            </div>
          </template>
        </PopoverSelect>
        <!-- 提币地址 -->
        <div class="tit">{{ $t('with').Withdrawaladdress }}</div>
        <PopoverSelect :items="addressList" :onSelect="onSelectAddress" v-if="!setAddress">
          <template #reference>
            <div class="addressInfo">
              <span>{{ Address | truncateAddress }}</span>
              <van-icon name="play" size="13" class="ric" color="var(--text_color)" />
            </div>
          </template>
        </PopoverSelect>
        <!-- 添加提币地址 -->
        <div class="addressInfo" v-else @click="$router.push({ name: 'AddWalletAddress' })">
          <span>{{ $t('with').Addwithdrawaladdress }}</span>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
      </div>
      <div class="right">
        <!-- 取款账户 -->
        <div class="tit">{{ $t('with').Withdrawalaccount }}</div>
        <PopoverSelect :items="assetTypeArr" :onSelect="onSelectAssetType">
          <template #reference>
            <div class="accountInfo">{{ assetType == 3 ?
              $t('asset').Spotaccount : $t('asset').Walletaccount }}
              <span><van-icon name="play" size="13" class="ric" color="var(--text_color)" /></span>
            </div>
          </template>
        </PopoverSelect>
        <!-- 提币数量 -->
        <div class="tit">{{ $t('with').Withdrawalquantity }}</div>
        <div class="numInfo">
          <van-field v-model="Amount" type="number" :placeholder="$t('recharge').amountMsg">
            <template #right-icon>
              <span style="color: var(--ntext_color)">{{ currency }}</span>
            </template>
          </van-field>
        </div>
        <!-- 资金密码 -->
        <div class="tit">{{ $t('safe').Fundcode }}</div>
        <div class="numInfo">
          <van-field v-model="password" :type="psdType" :placeholder=" $t('login').placeholder1" :right-icon="psdType === 'password' ? 'eye' : 'closed-eye'" @click-right-icon="psdType = psdType === 'password' ? 'text' : 'password'">
          </van-field>
        </div>
        <!-- 手续费 -->
        <div class="lables">{{ $t('position').changeRate }}<span>{{(Amount*0.02) .toFixed(6).replace(/\.?0+$/, '') }} {{ currency }}</span></div>
        <!-- 可用余额 -->
        <div class="lables">{{ $t('with').availablebalance }}<span>{{ AssetBalance.toFixed(2).replace(/\.?0+$/, '') }} {{ currency }}</span></div>
        <!-- 按钮 -->
        <van-button block :loading="btnloading" @click="handleSub">{{ $t('public').confirm }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import systemApi from '@/api/system'
import PopoverSelect from '@/components/popoverSelect.vue'
import { EventBus } from '@/utils/event-bus'

export default {
  components: {
    PopoverSelect,
  },
  data() {
    return {
      btnloading: false,
      baseUrl: window.baseURL,
      currency: 'USDT',
      currencyArr: [],
      network: '',
      networkArr: [],
      allnetworkArr: [],
      currencyNetwork: [],
      assetType: 4,
      addressList: [],
      Address: '',
      setAddress: false,
      Amount: '',
      password: '',
      psdType: "password", //输入框类型
      AssetBalance: 0,
      systemaddressList: [],
    }
  },
  computed: {
    assetTypeArr() {
      return [
        { text: this.$t('asset').Walletaccount, val: 4 },
        { text: this.$t('asset').Spotaccount, val: 3 },
      ]
    },
  },
  async mounted() {
    EventBus.$on('btnloading', () => {
      this.btnloading = false
    })
    window.scrollTo(0, 0);
    this.getMemberInfo()
    this.getSystemWalletAddressList()
  },
  methods: {
    // 获取用户信息
    async getMemberInfo() {
      const res = await userApi.getMemberInfo()
      // 资金密码判断
      if (!res.user.fundPassword) {
        this.$dialog.alert({
          title: this.$t('safe').Setfundpassword,
          confirmButtonText: this.$t('public').confirm,
          confirmButtonColor: 'var(--text_color)',
        })
          .then(() => {
            this.$router.push({ name: 'UpPayPwd' })
          })
      }
    },
    //查询用户钱包地址列表
    async getWalletAddressList() {
      this.Address = ''
      const res = await userApi.getWalletAddressList({ pageNum: 1, pageSize: 1000, currency: this.currency, network: this.network })
      this.addressList = res.rows.map(item => ({ val: item.address, text: item.address, }));
      //未设置地址
      if (this.addressList.length < 1) {
        this.setAddress = true
        this.Address = ''
        this.$dialog.confirm({
          title: this.$t('with').WithdrawaladdressTips,
          confirmButtonText: this.$t('public').confirm,
          confirmButtonColor: 'var(--text_color)',
          cancelButtonText: this.$t('public').cancel,
          cancelButtonColor: 'var(--ntext_color)',
        })
          .then(() => {
            this.$router.push({ name: 'AddWalletAddress' })
          })
      } else {
        this.setAddress = false
        this.Address = this.addressList[0].val
      }
    },
    //系统钱包地址
    async getSystemWalletAddressList() {
      const res = await systemApi.getWalletAddressList()
      this.systemaddressList = res.walletAddress
      this.currencyArr = Array.from(new Map(this.systemaddressList.map(item => [item.currency, { text: item.currency, val: item.currency }])).values());
      this.currency = this.currencyArr[0].val
      this.OnNetwork()
    },
    //网络赋值
    OnNetwork() {
      this.networkArr = Array.from(new Map(this.systemaddressList.filter(item => item.currency === this.currency).map(item => [item.network, { text: item.network, val: item.network }])).values())
      this.network = this.networkArr[0].val
      this.onChangeAll()
    },
    //选择币种
    async onSelectCurrency(action) {
      this.currency = action.text
      this.OnNetwork()
    },
    //选择网络
    async onSelectNetwork(val) {
      this.network = val.text
      this.onChangeAll()
    },
    //选择资产账户
    async onSelectAssetType(action) {
      this.assetType = action.val
      this.getAssetBalance()
    },
    //选择变动地址余额
    onChangeAll() {
      this.getWalletAddressList()
      this.getAssetBalance()
    },
    //选择地址
    async onSelectAddress(val) {
      this.Address = val.val
    },
    // 获取资产余额
    async getAssetBalance() {
      const res = await userApi.getAssetBalance({ assetType: this.assetType, currency: this.currency })
      this.AssetBalance = res.assetWallet.amount
    },
    // 提交
    async handleSub() {
      // 请选择地址
      if (!this.Address) {
        this.$toast(this.$t('with').selectWithdrawaladdress)
        return false
      }
      if (!this.Amount) {
        this.$toast({ message: this.$t('recharge').amountMsg })
        return false
      }
      if (!this.assetType) {
        this.$toast(this.$t('recharge').selectaccount)
        return false
      }
      if (!this.password) {
        this.$toast(this.$t('login').placeholder1)
        return false
      }
      // 可用余额不足
      if (this.Amount > this.AssetBalance) {
        this.$toast(this.$t('with').Insufficientavailablebalance)
        return false
      }
      const form = {
        amount: this.Amount,
        assetType: this.assetType,
        currency: this.currency,
        network: this.network,
        address: this.Address,
        password: this.password,
      }
      this.btnloading = true
      await userApi.withdrawalCurrency(form)
      this.btnloading = false
      this.$toast({ message: this.$t('recharge').subMsg })
      this.$router.go(-1)
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);

  .title {
    font-size: 36px;
    font-weight: bold;
    color: var(--text_color);
    margin: 0 auto;
    max-width: 1280px;
    padding-bottom: 40px;
    border-bottom: 1px solid var(--info_color);
    margin-bottom: 30px;
  }

  .info {
    margin: 0 auto;
    max-width: 1280px;
    display: flex;
    justify-content: space-between;

    .left {
      width: 50%;
      margin-right: 50px;
    }

    .right {
      width: 50%;
    }

    .tit {
      margin-top: 10px;
      font-size: 13px;
      color: var(--text_color);
    }

    .ric {
      transform: rotate(90deg);
    }

    .selInfo {
      margin: 10px 0 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid var(--info_color);
      border-radius: 10px;
      height: 50px;
      padding: 15px;

      &:hover {
        border: 1px solid var(--primary_color);
      }

      .left {
        display: flex;
        align-items: center;

        .img {
          width: 20px;
          height: 20px;
          border-radius: 50%;
        }

        .name {
          margin-left: 10px;
          font-size: 16px;
          font-weight: bold;
          color: var(--text_color);
        }
      }
    }

    .networkInfo {
      margin: 10px 0 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid var(--info_color);
      border-radius: 10px;
      padding: 15px;
      font-size: 16px;
      font-weight: bold;
      color: var(--text_color);

      &:hover {
        border: 1px solid var(--primary_color);
      }
    }

    .addressInfo {
      margin: 10px 0 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid var(--info_color);
      border-radius: 10px;
      height: 50px;
      padding: 15px;
      font-size: 14px;
      color: var(--text_color);

      &:hover {
        border: 1px solid var(--primary_color);
      }
    }

    .accountInfo {
      margin: 10px 0 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid var(--info_color);
      border-radius: 10px;
      padding: 15px;
      font-size: 16px;
      font-weight: bold;
      color: var(--text_color);

      &:hover {
        border: 1px solid var(--primary_color);
      }
    }

    .numInfo {
      margin-top: 10px;
    }

    .lables {
      margin-top: 10px;
      display: flex;
      align-items: center;
      font-size: 13px;
      color: var(--ntext_color);

      span {
        margin-left: 10px;
        color: var(--text_color);
        font-weight: bold;
      }
    }

    .van-button {
      margin: 50px 0;
      background: var(--primary_color);
      height: 50px;
      border-radius: 25px;
      border: 0;
      font-size: 16px;
      color: #fff;

      &:hover {
        opacity: 0.8;
      }
    }
  }
}

.itemss {
  padding: 15px;
  font-size: 14px;
  color: var(--text_color);

  &:hover {
    opacity: 0.7;
  }

  &:active {
    background: var(--background_color);
  }
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

.van-cell {
  background: var(--background_color);
  border: 1px solid var(--info_color);
  height: 50px;
  padding: 10px;
  border-radius: 10px;
  font-size: 20px;
  font-weight: bold;

  &:focus-within {
    border: 1px solid var(--primary_color);
    box-shadow: 1px 1px 2px var(--ntext_color);
  }
  &:hover {
    border: 1px solid var(--primary_color);
  }
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__right-icon {
  margin: -10px 8px;
  padding: 0px;
  line-height: normal;
  font-size: 15px;
}
</style>